import { render, staticRenderFns } from "./EditMealPlans.vue?vue&type=template&id=094209a4"
import script from "./EditMealPlans.vue?vue&type=script&lang=js"
export * from "./EditMealPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports